$(function () {
  $('a[href^="#"]').click(function () {
    let speed = 500;
    let href = $(this).attr("href");
    let target = $(href == "#" || href == "" ? 'html' : href);
    let position = target.offset().top - 130;
    $("html, body").animate({ scrollTop: position }, speed, "swing");
    return false;
  });

  $(window).on('scroll', function () {
    var scroll = $(window).scrollTop();
    var windowHeight = $(window).height();
    $('.effect-fade').each(function () {
      var elemPos = $(this).offset().top;
      if (scroll > elemPos - windowHeight) {
        $(this).addClass('effect-scroll');
      }
    });
  })

  $(window).on('load scroll', function () {
    var scroll = $(window).scrollTop();
    var windowH = $(window).height();
    var target = $('#main-bottom').offset().top;
    if (scroll > target - windowH) {
      $('.js-float-btn').fadeOut()
    } else {
      $('.js-float-btn').fadeIn()
    }
  })
});